import { Box, Stack } from '@mui/material';
import { useState } from 'react';

import { TourTravel } from '@/domain/project-tour-ontour/entities/project-tour-ontour-travel.entity';
import ArrowIncomingLeft from '@/ui/assets/arrow-incoming-left.svg';
import ArrowIncomingRight from '@/ui/assets/arrow-incoming-right.svg';

import { FavoriteTravelGroupOption } from '../../utils/tour-travel-favorite-group';
import { ModalTourTravelGroupForm } from '../tour-travel-view/ModalTourTravelGroupForm';
import { CityLabel } from './CityLabel';
import { TourTraveListIncomingEmpty } from './TourTraveListIncomingEmpty';
import { TourTravelItem } from './TourTravelItem';

export function TourTraveListIncoming({
  tourTravels,
  onClickDelete,
  onClickAdd,
  favoriteIds,
  onToggleFavorite,
  favoriteTravels,
  onCopyTravel,
  isWindowFavorite,
  onToggleWindowFavorite,
  favoriteGroups,
  onCopyGroup,
}: {
  tourTravels: TourTravel[];
  onClickDelete: (tourTravelId: number) => void;
  onClickAdd: () => void;
  favoriteIds: Set<number>;
  onToggleFavorite: (id: number) => void;
  favoriteTravels: TourTravel[];
  onCopyTravel: (sourceTourTravel: TourTravel) => void;
  isWindowFavorite: boolean;
  onToggleWindowFavorite: () => void;
  favoriteGroups: FavoriteTravelGroupOption[];
  onCopyGroup: (travels: TourTravel[]) => void;
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTravelIndex, setActiveTravelIndex] = useState(0);

  const onClickOpen = (index: number) => {
    setActiveTravelIndex(index);
    setModalOpen(true);
  };

  if (tourTravels.length === 0) {
    return <TourTraveListIncomingEmpty />;
  }

  return (
    <>
      <ModalTourTravelGroupForm
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        tourTravels={tourTravels}
        initialIndex={activeTravelIndex}
        onClickAdd={onClickAdd}
        onDelete={onClickDelete}
        favoriteIds={favoriteIds}
        onToggleFavorite={onToggleFavorite}
        favoriteTravels={favoriteTravels}
        onCopyTravel={onCopyTravel}
        isWindowFavorite={isWindowFavorite}
        onToggleWindowFavorite={onToggleWindowFavorite}
        favoriteGroups={favoriteGroups}
        onCopyGroup={onCopyGroup}
      />
      <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 0 }}>
        <Stack sx={{ alignItems: 'center', gap: 0 }}>
          {tourTravels.map((tourTravel, index) => (
            <Box key={tourTravel.id}>
              <Stack
                sx={{ flexDirection: 'row', alignItems: 'center', gap: 0 }}
              >
                <CityLabel tourTravel={tourTravel} />
                <Box sx={{ ml: 0.5 }}>
                  <img src={ArrowIncomingLeft} />
                </Box>
                <TourTravelItem
                  tourTravel={tourTravel}
                  onClickDelete={onClickDelete}
                  onClickOpen={() => onClickOpen(index)}
                  isFavorite={favoriteIds.has(tourTravel.id)}
                />
              </Stack>
            </Box>
          ))}
        </Stack>
        <Box sx={{ ml: -0.5, position: 'relative', top: -1.5 }}>
          <img src={ArrowIncomingRight} />
        </Box>
      </Stack>
    </>
  );
}
